import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardMedia, Typography, List, ListItem, ListItemText, Grid, Paper, Tabs, Tab, Chip, Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import { useHistory, useParams } from "react-router-dom";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ApiService from "../../_services/ApiService";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import NoResults from "../../components/reusableComponents/NoResults";
import SingleDataCard from "../../components/reusableComponents/SingleDataCard";
import D3LineChart from "../../components/reusableComponents/D3LineChart";
import { CardSkeletonCollab, CardSkeletonCount } from "../../components/reusableComponents/SkeletonCard";
import GigTableView from "./gigTableView";
import { getDateAsPerFormat } from "../../_helpers/reusablefunctions/dateSetter";
import ReusableTabs from "../../components/reusableComponents/reusableTabs";
import { formatCardData, getCurrentMonthAndWeek, transformData } from "../../components/reusableComponents/formatCardData";
import TablecomponentAnalytics from "../../components/reusableComponents/TablecomponentAnalytics";
import DynamicToggleTabs from "../../components/reusableComponents/DynamicToggleTabs";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import ReusableChip from "../../components/reusableComponents/chipSelector";
import GigApplicationPage from './GigApplicationPage';
import AddToDriveIcon from '@mui/icons-material/AddToDrive';
dayjs.extend(relativeTime);

const tabMap = {
    details: 0,
    analytics: 1,
    application: 2,
};

const sampleData1 = [
    { day: "Mon", value: 22 },
    { day: "Tue", value: 8 },
    { day: "Wed", value: 24 },
    { day: "Thurs", value: 30 },
    { day: "Fri", value: 35 },
    { day: "Sat", value: 12 },
    { day: "Sun", value: 20 },
];

const sampleData2 = [
    { month: "Jan", value: 50 },
    { month: "Feb", value: 70 },
    { month: "Mar", value: 60 },
    { month: "Apr", value: 80 },
    { month: "May", value: 90 },
    { month: "Jun", value: 40 },
];
const ViewGigManagement = () => {
    const history = useHistory();
    const { gigId, tabName } = useParams();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData
    const [loader, setLoader] = useState(false);
    // const [offerViewList, setOfferViewList] = useState(locationEventDetail);
    const [value, setValue] = React.useState(
        tabMap[tabName] ?? 0
    );
    const [formattedData, setFormattedData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [chartDataApply, setChartDataApply] = useState([]);
    const [chartDataCreator, setChartDataCreator] = useState([]);
    const [chartDataApplyCreator, setChartDataApplyCreator] = useState([]);
    const [chartFullData, setChartFullData] = useState([]);
    const [chartFullDataApply, setChartFullDataApply] = useState([]);
    const [chartFullDataCreator, setChartFullDataCreator] = useState([]);
    const [chartFullDataApplyCreator, setChartFullDataApplyCreator] = useState([]);
    const { month, week } = getCurrentMonthAndWeek();
    const [revnueValue, setRevnueValue] = useState('Youth');
    const [offerViewList, setOfferViewList] = useState(null);
    const [loadingGig, setLoadingGig] = useState(false);

    const backClickHistory = () => {
        history.push('/gig-management')
    }
    // useEffect(() => {
    //     if (!gigId) return;

    //     setLoadingGig(true);

    //     ApiService.get("gigsview", {}, gigId) // or `gigs/${gigId}` depending on your API
    //         .then((res) => {
    //             if (res?.status === 200 || res?.status === 201) {
    //                 setOfferViewList(res.data.data);
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching gig details", err);
    //         })
    //         .finally(() => setLoadingGig(false));
    // }, [gigId]);

    const fetchGigDetails = async ({
        limit = 10,
        offset = 0,
        Status = "",
        search = "",
    } = {}) => {
        if (!gigId) return;

        setLoadingGig(true);

        try {
            const res = await ApiService.get(
                "gigsview",
                { limit, offset, Status, search },
                gigId
            );

            if (res?.status === 200 || res?.status === 201) {
                setOfferViewList(res.data.data);
            }
        } catch (err) {
            console.error("Error fetching gig details", err);
        } finally {
            setLoadingGig(false);
        }
    };

    useEffect(() => {
        fetchGigDetails();
    }, [gigId]);
    // -----------------

    useEffect(() => {
        setLoader(true);

        Promise.all([
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/gig/${gigId}/students`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/gig/${gigId}/students`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/gig/${gigId}/creators/`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/gig/${gigId}/creators/`
            )
        ])
            .then(([offerRes, applyRes, offerCreatRes, applyCreatRes]) => {
                if (
                    (offerRes?.status === 200 || offerRes?.status === 201) &&
                    (applyRes?.status === 200 || applyRes?.status === 201) &&
                    (offerCreatRes?.status === 200 || offerCreatRes?.status === 201) &&
                    (applyCreatRes?.status === 200 || applyCreatRes?.status === 201)
                ) {
                    const formattedCardData = formatCardData([
                        { label: 'Youth Clicks', count: offerRes?.data?.data?.total_clicks },
                        { label: 'Number of Youth', count: applyRes?.data?.data?.total_applied },
                        // { label: '', count: null },
                        // { label: ' ', count: null },
                    ]);
                    setChartFullData(offerRes?.data?.data)
                    setChartFullDataApply(applyRes?.data?.data)
                    setFormattedData(formattedCardData);
                    const transformed = transformData(offerRes?.data?.data?.week_wise);
                    setChartData(transformed);
                    const transformedApply = transformData(applyRes?.data?.data?.applications_by_week);
                    setChartDataApply(transformedApply);

                    setChartFullDataCreator(offerCreatRes?.data?.data);
                    setChartFullDataApplyCreator(applyCreatRes?.data?.data);
                    const transformedCreator = transformData(offerCreatRes?.data?.data?.week_wise);
                    setChartDataCreator(transformedCreator);
                    const transformedApplyCreator = transformData(applyCreatRes?.data?.data?.applications_by_week);
                    setChartDataApplyCreator(transformedApplyCreator);
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            })
            .finally(() => setLoader(false));
    }, [month, week, gigId]);

    const handleTimeFrameChange = (value) => {
        setChartData(value === "This Week" ? sampleData1 : sampleData2);
    };

    // --------- switch tab for analytics
    const handleTabSelect = (newValue) => {
        const tabValue = newValue === 1 ? 'Creators' : 'Youth';
        setRevnueValue(tabValue)
    };

    const shortTimeAgo = (date) => {
        const seconds = Math.floor((new Date() - new Date(date)) / 1000);

        const intervals = [
            { label: "year", seconds: 31536000 },
            { label: "month", seconds: 2592000 },
            { label: "week", seconds: 604800 },
            { label: "day", seconds: 86400 },
            { label: "hour", seconds: 3600 },
            { label: "minute", seconds: 60 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(seconds / interval.seconds);
            if (count >= 1) return `${count} ${interval.label} ago`;
        }

        return "Just now";
    };

    // build structured target audience data (put this above return)
    const targetAudience = [
        { title: "Audience Type", content: offerViewList?.GigWorkType?.map(d => d.TypeName) || [] },
        { title: "Industry Category", content: offerViewList?.industry_category?.map(d => d.TypeName) || [] },
        { title: "Age Range", content: (offerViewList?.target_age_min && offerViewList?.target_age_max) ? [`${offerViewList.target_age_min} - ${offerViewList.target_age_max} years`] : [] },
        { title: "Gender", content: offerViewList?.target_gender ? [offerViewList.target_gender] : [] },
        { title: "Interests", content: offerViewList?.target_interests ? [offerViewList.target_interests] : [] },
        ...(Array.isArray(offerViewList?.platforms) && offerViewList.platforms.length ? [{ title: "Platforms", content: offerViewList.platforms.map(p => p.platformName) }] : []),
        ...(Array.isArray(offerViewList?.industry_category) && offerViewList.industry_category.length ? [{ title: "Industry", content: offerViewList.industry_category.map(i => i.TypeName) }] : [])
    ];

    const renderChips = (content) => {
        const array = Array.isArray(content) ? content : (content ? [content] : []);

        return array.map((item, i) => (
            <Tooltip key={i} title={item} arrow>
                <Box sx={{ maxWidth: "100%" }}>
                    <ReusableChip
                        label={item}
                        bgcolor="#E8E8E8"
                        color="#7A7A7A"
                        borderRadius="6px"
                        sx={{
                            padding: "16px 16px",
                            fontSize: 14,
                            cursor: "pointer",

                            /* 🔥 IMPORTANT */
                            maxWidth: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    />
                </Box>
            </Tooltip>
        ));
    };
    // small helper to render grouped audience items in two columns
    const renderTargetAudience = (items) => (
        <Grid container spacing={2}>
            {items.map((t, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                    <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#666', mb: 1 }}>{t.title}</Typography>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                            overflow: "hidden",
                            maxWidth: "100%",
                        }}
                    >
                        {renderChips(t.content.length ? t.content : ["Not specified"])}
                    </Box>

                </Grid>
            ))}
        </Grid>
    );



    const reverseTabMap = {
        0: "details",
        1: "analytics",
        2: "application",
    };
    useEffect(() => {
        if (tabMap[tabName] !== undefined) {
            setValue(tabMap[tabName]);
        }
    }, [tabName]);

    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} >
                <ReusableHeadingComponents bacHistory={true} clickHandlerBack={backClickHistory} heading={`${offerViewList?.Title}`} />
                <Box>
                    {/* <ReusableButton children={'Close gig'} variant="contained"
                        classNames={'gn-actionbtn'} /> */}
                    {/* <ReusableButton children={'Edit'} variant="contained"
                        classNames={'gn-actionbtn'} /> */}
                </Box>
            </Box>
            {/* --------------- cards ------------ */}
            <Box sx={{ display: 'flex', gap: '20px' }}>
                {loader ? (
                    ['', '', '', ''].map((d, i) => (
                        <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                            <CardSkeletonCount />
                        </Grid>
                    ))
                ) : (formattedData && formattedData.map((item, index) => (
                    <SingleDataCard
                        key={index}
                        cardHeading={item.label}
                        count={item.value}
                        bg={item.bgcolor}
                        cardbg={item.cardbg}
                        Icon={item.Icon}
                        iconColor={item.iconColor}
                    />)
                ))}
            </Box>

            {/* 0---------------- tab switch analytics and offer details ------------- */}

            <Box sx={{ width: '100%', mt: 3 }}>
                {/* <ReusableTabs setValue={setValue} value={value} /> */}
                <ReusableTabs
                    value={value}
                    setValue={(newValue) => {
                        setValue(newValue);
                        history.push(
                            `/gig-management/view-gig/${gigId}/${reverseTabMap[newValue]}`
                        );
                    }}
                />
            </Box>

            {value == 0 ? (<Grid container spacing={2} mt={3}>
                <Grid item xs={12} sm={12} md={8} lg={8} >
                    {/* -------- overview ---------------- */}

                    <Grid container spacing={2}>

                        {/* CARD 1 — Banner */}
                        <Grid item xs={12} sm={6}>
                            <ReusableCardView
                                padding={0}
                                // title="Banner Image"
                                Component={
                                    <Box sx={{ width: "100%", height: 190, pt: "0px !important" }}>
                                        {offerViewList?.Featured_Banner_URL || offerViewList?.Featured_Banner ? (
                                            <img
                                                src={offerViewList?.Featured_Banner_URL || offerViewList?.Featured_Banner}
                                                alt="Banner"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: 8
                                                }}
                                                onError={(e) => (e.currentTarget.style.display = "none")}
                                            />
                                        ) : (
                                            <Typography>No banner available</Typography>
                                        )}
                                    </Box>
                                }
                            />
                        </Grid>

                        {/* CARD 2 — Meta Info */}
                        <Grid item xs={12} sm={6}>
                            <ReusableCardView
                                // title="Gig Details"
                                Component={
                                    <Box p={"0px 16px 16px 16px"}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, marginBottom: 2 }}>
                                            {(offerViewList?.BrandLogoURL || offerViewList?.BrandLogo) && (<Box sx={{ height: 70, width: 70 }}>
                                                <img src={offerViewList?.BrandLogoURL || offerViewList?.BrandLogo} className="w-100 h-100 object-fit-contain" />
                                            </Box>)}
                                            <Box>
                                                {offerViewList?.RewardAmount && (<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: '16px', color: '#F3676C' }}>
                                                    Payment : <span style={{ fontWeight: "normal", color: "#D81921" }}>₹{offerViewList?.RewardAmount}</span>
                                                </Typography>)}
                                                {offerViewList?.updated_at && (<Typography
                                                    variant="h6"
                                                    sx={{ fontWeight: 400, fontSize: "12px", marginTop: 1, color: "#757575", justifyContent: 'flex-end', display: 'flex' }}
                                                >
                                                    {shortTimeAgo(offerViewList?.updated_at)}
                                                </Typography>)}

                                            </Box>
                                        </Box>
                                        <Box>
                                            {offerViewList?.BrandName && (<Typography sx={{ color: "#A5A5A5", fontSize: '14px' }}>
                                                {offerViewList?.BrandName}
                                            </Typography>)}
                                            {offerViewList?.Title && (<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: '18px', marginTop: 1, color: '#222222', marginBottom: 2 }}>
                                                {offerViewList?.Title}
                                            </Typography>)}
                                        </Box>
                                    </Box>
                                }
                            />
                        </Grid>



                        {/* CARD 3 — Gig Overview */}
                        <Grid item xs={12} sm={12}>
                            <ReusableCardView
                                title="Gig Overview"
                                Component={
                                    <Typography
                                        sx={{ color: "#666", padding: "0px 16px 16px 16px" }}
                                        dangerouslySetInnerHTML={{ __html: offerViewList?.AboutGigWork }}
                                    />
                                }
                            />
                        </Grid>

                        {/* NEW CARD — Content Requirements (updated to match deliverable style) */}
                        {offerViewList?.content_requirements && offerViewList.content_requirements.length > 0 && (
                            <Grid item xs={12}>
                                <ReusableCardView
                                    title="Content Requirements"
                                    Component={
                                        <Box sx={{ padding: "0px 16px 16px 16px" }}>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
                                                <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#666' }}>
                                                    No. of Deliverables
                                                </Typography>

                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        gap: 1,
                                                        alignItems: 'center',
                                                        // backgroundColor: '#f2f2f2',
                                                        borderRadius: '8px',
                                                        padding: '8px',
                                                    }}
                                                >
                                                    {offerViewList.content_requirements.map((item, idx) => {
                                                        const label = `${item.quantities} ${item.format}`;
                                                        return (
                                                            <Tooltip key={idx} title={label}>
                                                                <ReusableChip
                                                                    label={label}
                                                                    bgcolor="#E8E8E8"
                                                                    color="#7A7A7A"
                                                                    borderRadius="6px"
                                                                    sx={{ padding: '16px 16px', fontSize: 14, whiteSpace: 'normal' }}
                                                                />
                                                            </Tooltip>
                                                        );
                                                    })}
                                                </Box>
                                            </Box>
                                        </Box>
                                    }
                                />
                            </Grid>
                        )}

                        {/* NEW CARD — Reference Links */}
                        {Array.isArray(offerViewList?.reference_links) &&
                            offerViewList.reference_links.length > 0 && (
                                <Grid item xs={12}>
                                    <ReusableCardView
                                        title="Reference Links"
                                        Component={
                                            <Box sx={{ padding: "0px 16px 16px 16px" }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexWrap: "wrap",
                                                        gap: "12px",
                                                    }}
                                                >
                                                    {offerViewList.reference_links.map((ref, idx) => (
                                                        <Box
                                                            mt={1}
                                                            key={idx}
                                                            component="a"
                                                            href={ref.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            sx={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: "6px",
                                                                padding: { xs: '6px 20px', md: "6px 46px" },
                                                                border: "1px solid #1976D2",
                                                                borderRadius: "2px",
                                                                color: "#1976D2",
                                                                fontSize: "14px",
                                                                fontWeight: 500,
                                                                textDecoration: "none",
                                                                cursor: "pointer",
                                                                backgroundColor: "#fff",
                                                                transition: "all 0.2s ease",
                                                                "& svg": {
                                                                    fontSize: "18px",
                                                                    color: "#1976D2",
                                                                },
                                                                "&:hover": {
                                                                    backgroundColor: "#1976D2",
                                                                    color: "#fff",
                                                                    "& svg": {
                                                                        color: "#fff",
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <AddToDriveIcon />
                                                            View {idx + 1}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            </Box>
                                        }
                                    />
                                </Grid>
                            )}

                        {/* CARD 6 — FAQ */}
                        {offerViewList?.FAQ && (
                            <Grid item xs={12}>
                                <ReusableCardView
                                    title="FAQ"
                                    Component={
                                        <Typography
                                            sx={{ color: "#666", p: 2 }}
                                            dangerouslySetInnerHTML={{ __html: offerViewList?.FAQ }}
                                        />
                                    }
                                />
                            </Grid>
                        )}

                    </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <ReusableCardView
                                title="Payment & Work Details"
                                Component={
                                    <Box sx={{ padding: "8px 16px 16px 16px" }}>
                                        <Grid container spacing={2}>
                                            {offerViewList?.payment_type && (
                                                <Grid item xs={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: '14px', color: '#666', mb: 0.5 }}>
                                                        Payment Type
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: "400", fontSize: '12px', color: "#7A7A7A" }}>
                                                        {offerViewList?.payment_type}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {offerViewList?.commission && (
                                                <Grid item xs={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: '14px', color: '#666', mb: 0.5 }}>
                                                        Commission
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: "400", fontSize: '12px', color: "#7A7A7A" }}>
                                                        {offerViewList?.commission}
                                                    </Typography>
                                                </Grid>
                                            )}

                                            {offerViewList?.payment_terms && (
                                                <Grid item xs={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: '14px', color: '#666', mb: 0.5 }}>
                                                        Payment Terms
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: "400", fontSize: '12px', color: "#7A7A7A" }}>
                                                        {offerViewList?.payment_terms}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {offerViewList?.location_workplace && (
                                                <Grid item xs={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: '14px', color: '#666', mb: 0.5 }}>
                                                        Workplace
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: "400", fontSize: '12px', color: "#7A7A7A", textTransform: 'capitalize' }}>
                                                        {offerViewList?.location_workplace}
                                                    </Typography>
                                                </Grid>
                                            )}
                                            {offerViewList?.revisions_allowed && (
                                                <Grid item xs={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: "bold", fontSize: '14px', color: '#666', mb: 0.5 }}>
                                                        Revisions Allowed
                                                    </Typography>
                                                    <Typography sx={{ fontWeight: "400", fontSize: '12px', color: "#7A7A7A" }}>
                                                        {offerViewList?.revisions_allowed}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Box>
                                }
                            />
                        </Grid>

                        {(offerViewList?.target_age_min || offerViewList?.target_gender || offerViewList?.target_interests || (offerViewList?.GigWorkType?.length)) && (
                            <Grid item xs={12} sm={12}>
                                <ReusableCardView
                                    title="Target Audience"
                                    Component={
                                        <Box sx={{ padding: "8px 16px 16px 16px" }}>
                                            <Box>
                                                {renderTargetAudience([
                                                    targetAudience[0],
                                                    targetAudience[1],
                                                    targetAudience[2],
                                                    targetAudience[3]
                                                ])}
                                            </Box>
                                        </Box>
                                    }
                                />
                            </Grid>
                        )}

                        {/* {offerViewList?.platforms && offerViewList.platforms.length > 0 && (
                            <Grid item xs={12} sm={12}>
                                <ReusableCardView
                                    title="Platforms"
                                    Component={
                                        <Box sx={{ padding: "8px 16px 16px 16px" }}>
                                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
                                                {renderChips(offerViewList.platforms.map(p => p.platformName))}
                                            </Box>
                                        </Box>
                                    }
                                />
                            </Grid>
                        )} */}
                        {offerViewList?.platforms && offerViewList.platforms.length > 0 && (
                            <Grid item xs={12} sm={12}>
                                <ReusableCardView
                                    title="Platforms"
                                    Component={
                                        <Box
                                            sx={{
                                                padding: "8px 16px 16px 16px",
                                                display: "flex",
                                                gap: 1.5,
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {offerViewList.platforms.map((platform, idx) => {
                                                const logoUrl = platform.platform_logo
                                                    ? `${process.env.REACT_APP_BASEURL_MEDIA}${platform.platform_logo}`
                                                    : null;

                                                return (
                                                    <Tooltip key={idx} title={platform.platformName}>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 1,
                                                                border: "1px solid #E0E0E0",
                                                                borderRadius: "8px",
                                                                padding: "8px 12px",
                                                                backgroundColor: "#FAFAFA",
                                                            }}
                                                        >
                                                            {/* Platform Logo */}
                                                            {logoUrl ? (
                                                                <Box
                                                                    component="img"
                                                                    src={logoUrl}
                                                                    alt={platform.platformName}
                                                                    sx={{
                                                                        width: 38,
                                                                        height: 38,
                                                                        objectFit: "contain",
                                                                        borderRadius: "50%",
                                                                        padding: "4px",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Typography sx={{ fontSize: 12, color: "#999" }}>
                                                                    No Logo
                                                                </Typography>
                                                            )}

                                                            {/* Platform Name */}
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    fontWeight: 500,
                                                                    color: "#555",
                                                                }}
                                                            >
                                                                {platform.platformName}
                                                            </Typography>
                                                        </Box>
                                                    </Tooltip>
                                                );
                                            })}
                                        </Box>
                                    }
                                />
                            </Grid>
                        )}

                        {offerViewList?.Completethetask && (
                            <Grid item xs={12}>
                                <ReusableCardView
                                    title="Steps to Complete the Task"
                                    Component={
                                        <Typography
                                            sx={{ color: "#666", p: 2 }}
                                            dangerouslySetInnerHTML={{ __html: offerViewList?.Completethetask }}
                                        />
                                    }
                                />
                            </Grid>
                        )}

                        {offerViewList?.Requirements && (
                            <Grid item xs={12}>
                                <ReusableCardView
                                    title="Requirements"
                                    Component={
                                        <Typography
                                            sx={{ color: "#666", p: 2 }}
                                            dangerouslySetInnerHTML={{ __html: offerViewList?.Requirements }}
                                        />
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>

            </Grid>)
                : value === 1 ?
                    (<Box>
                        <Box className='d-flex justify-content-end align-items-center flex-wrap'>
                            <DynamicToggleTabs value1="Youth" value2="Creators" onSelectTab={handleTabSelect} revnueValue={revnueValue} />
                        </Box>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={12} sm={12} md={6} lg={6} >
                                <ReusableCardView title="User Insight " Component={
                                    (revnueValue === 'Youth' ? chartData : chartDataCreator).length ? <Box >
                                        <D3LineChart
                                            data={revnueValue === 'Youth' ? chartData : chartDataCreator}
                                            xKey={(revnueValue === 'Youth' ? chartData : chartDataCreator)[0]?.day ? "day" : "month"}
                                            yKey="value"
                                            title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Clicks`}
                                            color="#4F46E5"
                                            width={500}
                                            height={250}
                                        />
                                    </Box>
                                        :
                                        loader ? (
                                            [''].map((d, i) => (
                                                <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                    <CardSkeletonCollab />
                                                </Grid>
                                            ))
                                        ) : null
                                } />
                            </Grid>

                            <Grid item xs={12} sm={12} md={6} lg={6} >
                                <ReusableCardView title="Application Over Time " Component={
                                    (revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator).length ? <Box >
                                        <D3LineChart
                                            data={revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator}
                                            xKey={(revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator)[0]?.day ? "day" : "month"}
                                            yKey="value"
                                            title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Applied Applicants`}
                                            color="#4F46E5"
                                            width={500}
                                            height={250}
                                        />
                                    </Box> :
                                        loader ? (
                                            [''].map((d, i) => (
                                                <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                    <CardSkeletonCollab />
                                                </Grid>
                                            ))
                                        ) : null
                                } />
                            </Grid>
                            {/* -------------------- Applicants table data -------------- */}
                            <Grid item xs={12} sm={12} md={12} lg={12} >
                                {/* <GigTableView /> */}
                                {/* <ReusableCardView title="Gig Clicks" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullData : chartFullDataCreator} title="Clicks" />} /> */}
                                <ReusableCardView title="Gig Applied" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullDataApply : chartFullDataApplyCreator} title="Applied" />} />
                            </Grid>
                        </Grid>
                    </Box>) :
                    value === 2 ? (
                        <Box mt={3}>
                            <GigApplicationPage
                                applications={offerViewList?.requestgigwork || []}
                                gigData={offerViewList}
                                gigId={gigId}
                                refreshGigDetails={fetchGigDetails}
                            />
                        </Box>
                    ) : null
            }


        </Box>
    );
};

export default ViewGigManagement;